import './index.css'
import App from './app/App'

if (document.readyState === 'complete' || document.readyState === 'interactive') {
	new App()
} else {
	document.addEventListener('DOMContentLoaded', () => new App())
}
